import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { PusherService } from 'src/app/services/pusher.service';
import { Router } from '@angular/router';
import { Storage } from '@ionic/storage';
import { finalize } from 'rxjs/operators';
import { BasePage } from './../../base.page';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from './../../../services/auth.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { shcAccessToken } from 'src/app/constants/general.constant';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { LoadingController, Platform, ToastController, NavController } from '@ionic/angular';
import { InAppService } from 'src/app/services/in-app.service';

@Component({
  selector: 'shc-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss']
})
export class LoginPage extends BasePage implements OnInit {
  loginForm: UntypedFormGroup;
  showPassword = false;

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private router: Router,
    private storage: Storage,
    private pusherService: PusherService,
    private navController: NavController,
    public inAppService: InAppService
  ) {
    super(platform, userService, authService, translate, loadingCtrl, toastController);
  }

  ngOnInit() {
    const emailPattern = '[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,63}';
    this.loginForm = new UntypedFormGroup({
      email: new UntypedFormControl(null, [
        Validators.required,
        Validators.email,
        Validators.pattern(emailPattern)
      ]),
      password: new UntypedFormControl(null, [
        Validators.required
      ])
    });
  }

  ionViewWillEnter() {
    this.autoLogin();
  }

  /**
   * If valid token is present, it will auto login the user
   */
  autoLogin(): void {
    this.storage.get(shcAccessToken).then(user => {
      if (user && user.access_token) {
        this.router.navigate(['/tabs/home']);
      }
    });
  }

  onLogin(): void {
    this.loginForm.markAllAsTouched();
    if (this.loginForm.invalid) {
      return;
    }
    this.showLoader();
    this.authService.login(this.loginForm.value).pipe(
      finalize(() => this.hideLoader())
    ).subscribe(
      res => {
        this.pusherService.initializePusher();
        if(res?.user?.is_first_login) {
          if (this.platform.is('ios')) {
            this.navController.navigateRoot(['/choose-language']);
          } else {
            this.router.navigate(['/choose-language'], {
              replaceUrl: true
            });
          }

        } else {
          this.translate.use(res?.user?.locale);
          this.translate.setDefaultLang(res?.user?.locale);

          if (this.platform.is('ios')) {
            this.navController.navigateRoot(['/tabs/home']);
          } else {
            this.router.navigate(['/tabs/home'], {
              replaceUrl: true
            });
          }
        }
      },
      error => {
        if (error.status === 406) {
          this.showToast(this.translate.instant(marker('Auth.PendingVerification')));
          this.authService.resendVerificationCode({ email: this.loginForm.value.email }).subscribe(res => {
            this.showToast(this.translate.instant(marker('Auth.ResentCode'), { email: this.loginForm.value.email}));
            this.router.navigate(['/auth/verify'], { state: { email: this.loginForm.value.email } });
          }, err => {
            this.errorService.handle(err);
          });
        } else {
          this.errorService.handle(error);
        }
      }
    );
  }

}
